<template>
  <footer>
    <div class="wrapper">
      <!-- <div class="footerNav">
        <div class="left">
          <router-link :to="{ path: '/' }" class="text">{{
            $t('Home.title1')
          }}</router-link>
          <router-link :to="{ path: '/introduction' }" class="text">{{
            $t('Home.title2')
          }}</router-link>
          <router-link :to="{ path: '/latestNews' }" class="text">{{
            $t('Home.title3')
          }}</router-link>
        </div>
        <div class="right">
          <router-link :to="{ path: '/coop/mode' }" class="text">{{
            $t('Home.title4')
          }}</router-link>
          <router-link :to="{ path: '/community' }" class="text">{{
            $t('Home.title5')
          }}</router-link>
        </div>
      </div> -->
      <div class="contact-us" id="contact-us">
        <!-- <span class="title">{{ $t('Home.title6') }}</span>
        <input class="emailInput" type="text" placeholder="Enter your E-mail" />
        <span class="prompt" v-html="showPrompt"></span>
        <button @click="saveEmail">contact us</button> -->
        <img
          src="./../../assets/resource/home/weixin.jpg"
          class="qrcode"
          width="120"
          height="120"
          alt=""
        />
      </div>
      <div class="footer-logo">
        <img src="./../../assets/resource/home/footer-logo.png" alt="" />
      </div>
      <div class="floatWrapper">
        <!-- <div class="contact-infoleft">
          <a
            href="https://files.istemedu.com/broswers/HappyCoding.exe"
            target="_blank"
            rel="noopener noreferrer"
            ><span class="infoleftSpan1">下载畅学编程HappyCoding编程工具</span>
            <div class="infoleftSpan11"></div>
            <span class="infoleftSpan2">支持windows7及以上操作系统</span></a
          >
        </div> -->
        <div class="contact-information">
          <span class="email">
            <i class="fa fa-envelope fa-1x"></i>
            marketer@istemedu.com</span
          >
          <span class="phoneNubmer">
            <i class="fa fa-phone-square fa-1x"></i>
            <span>021-80181777</span>
            <span>18094239115</span>
          </span>
        </div>
      </div>
      <div class="help">
        <a
          href="https://cx.istemedu.com/detection"
          target="_blank"
          >{{ $t('Product.systemDetection') }}</a
        >
        <a :href="hrefChrome"
          >{{ $t('DownChromeTip') }}{{ $t('ChromeBrower') }}</a
        >
      </div>
      <div id="license">
        <a style="padding-right: 10px;" href="https://beian.miit.gov.cn/">沪ICP备17012874号-5</a>
        <a href="https://beian.mps.gov.cn/">沪公网安备31010502007517号</a>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      showPrompt: '',
      hrefChrome: 'https://www.google.cn/chrome/'
    }
  },
  created() {
        // this.downloadChrome()
    },
  methods: {
    saveEmail() {
      let data = document.querySelector('.emailInput').value
      axios
        .post('/bomb/emails', {
          email: data
        })
        .then(res => {
          this.showPrompt = '提交成功!'
          document.querySelector('.prompt').style.color = '#162d55'
          setTimeout(() => {
            this.showPrompt = ''
          }, 1000)
        })
        .catch(() => {
          this.showPrompt = '提交失败!'
          document.querySelector('.prompt').style.color = 'red'
          setTimeout(() => {
            this.showPrompt = ''
          }, 1000)
        })
    },
    downloadChrome() {
            const platform = require('platform')
            let userAgent = navigator.userAgent
            let isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows') || userAgent.indexOf('Win64') > -1
            let isWinXP = userAgent.indexOf('Windows NT 5.1') > -1 || userAgent.indexOf('Windows XP') > -1
            let isAndriod, isios, ismac
            let ret = platform.os.toString()
            isAndriod = ret.toLowerCase().search('android') > -1
            isios = ret.toLowerCase().search('ios') > -1
            ismac = ret.toLowerCase().search('os x') > -1
            if (isWin) {
                if (isWinXP) {
                    this.hrefChrome = 'https://files.istemedu.com/broswers/49.0.2623.75_chrome_installer.exe'
                } else {
                    this.hrefChrome = 'https://files.istemedu.com/broswers/ChromeStandalone_62.0.3202.75_Setup.exe'
                }
            } else if (isAndriod) {
                this.hrefChrome = 'https://files.istemedu.com/broswers/Chrome_316309801.apk'
            } else if (isios) {
                this.hrefChrome = 'https://itunes.apple.com/cn/app/id535886823'
            } else if (ismac) {
                this.hrefChrome = 'https://files.istemedu.com/broswers/googlechrome_mac_60.0.3112.101.dmg'
            }
        }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  footer {
    width: 100%;
    background: #e6e7e7;
    .wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .footerNav {
        float: left;
        .left {
          // width: 94px;
          height: 112px;
          float: left;
          margin-left: 51px;
          margin-top: 49px;
        }
        .right {
          // width: 94px;
          height: 67px;
          float: left;
          margin-left: 36px;
          margin-top: 49px;
        }
        a {
          display: block;
          font-size: 1.5rem;
          color: #595757;
          letter-spacing: -1px;
          line-height: 38px;
          font-family: PingFangSC-Light;
        }
      }
      .contact-us {
        width: 130px;
        height: 130px;
        // margin-right: 124px;
        float: right;
        // margin: 38px 0px;
        position: relative;
        .title {
          font-size: 1.5rem;
          color: #595757;
          letter-spacing: -1px;
          line-height: 38px;
          font-family: PingFangSC-Light;
          display: block;
          line-height: 23px;
        }
        .qrcode {
          // margin-top: 25px;
          position: absolute;
          left: 30px;
          top: 20px;
          width: 100px;
          height: 100px;
        }
        input {
          width: 265px;
          height: 47px;
          border: none;
          padding: 10px;
          font-size: 1rem;
          margin-top: 30px;
        }
        .prompt {
          position: absolute;
          color: #162d55;
          font-size: 14px;
          text-align: center;
          width: 265px;
          margin-top: -4px;
        }
        button {
          width: 265px;
          height: 40px;
          margin-top: 14px;
          padding: 11px 68px;
          font-size: 26px;
          background: #162d55;
          color: #fff;
          line-height: 18px;
          font-family: PingFangSC-Thin;
        }
      }
      .footer-logo {
        img {
          width: 100%;
          margin-top: 16px;
        }
      }
      .floatWrapper {
        display: flex;
        justify-content: center;
        padding: 6px;
        margin-left: 22px;
        // display: flex;
        .contact-infoleft {
          float: left;
          margin-left: 100px;
          a {
            color: red;
            border-radius: 10px;
            cursor: pointer;
            box-sizing: border-box;
            .infoleftSpan1 {
              padding: 8px 12px;
              border: 1px dashed #ccc;
            }
            .infoleftSpan11{
              height: 10px;
            }
            .infoleftSpan2 {
              font-size: 14px;
              padding: 0 47px;
              // padding: 8px 12px;
              // border: 1px dashed #ccc;
            }
          }
          // width: 100%;
        }
        .contact-information {
          float: right;
          margin-right: 42px;
          // margin-top: -16px;
          color: #595757;
          font-family: AdobeInvisFont;
          font-size: 0px;
          user-select: text;
          .email {
            line-height: 1.25rem;
            font-size: 1rem;
            vertical-align: top;
            i {
              vertical-align: top;
            }
          }
          .phoneNubmer {
            line-height: 1.25rem;
            font-size: 1rem;
            margin-left: 11px;
            display: inline-block;
            max-width: 16rem;
            text-align: end;
          }
        }
        &::after {
          content: '.';
          clear: both;
          width: 0;
          height: 0;
          display: block;
          visibility: hidden;
        }
      }
      .help {
        text-align: center;
        margin: 5px;
        a {
          color: #595757;
        }
      }
      #license {
        clear: both;
        text-align: center;
        padding-bottom: 15px;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  footer {
    width: 100%;
    background: #e6e7e7;
    .wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .footerNav {
        float: left;
        margin: 14px 0 0 40px;
        a {
          display: block;
          font-size: 1.2rem;
          color: #595757;
          letter-spacing: -1px;
          line-height: 30px;
          font-family: PingFangSC-Light;
        }
      }
      .contact-us {
        // width: 200px;
        float: right;
        margin: 38px 0px;
        position: relative;
        .title {
          font-size: 1.2rem;
          color: #595757;
          letter-spacing: -1px;
          line-height: 38px;
          font-family: PingFangSC-Light;
          display: block;
          line-height: 23px;
        }
        .qrcode {
          // margin-top: 25px;
          // position: absolute;
          // left: 130px;
          // top: -47px;
          margin-top: 10px;
          width: 100px;
          height: 100px;
        }
        input {
          width: 200px;
          height: 47px;
          border: none;
          padding: 10px;
          font-size: 1rem;
          margin-top: 10px;
        }
        button {
          width: 200px;
          height: 40px;
          margin-top: 14px;
          font-size: 26px;
          background: #162d55;
          color: #fff;
          line-height: 18px;
          font-family: PingFangSC-Thin;
          text-align: -webkit-left;
          padding-left: 10px;
        }
      }
      .footer-logo {
        img {
          width: 100%;
          margin-top: 16px;
        }
      }
      .floatWrapper {
        display: flex;
        justify-content: center;
        padding: 6px;
        margin-left: 22px;
        .contact-information {
          margin-right: 42px;
          // margin-top: -16px;
          color: #595757;
          font-family: AdobeInvisFont;
          font-size: 0px;
          user-select: text;
          text-align: center;
          .email {
            line-height: 1.25rem;
            font-size: 1rem;
            vertical-align: top;
            i {
              vertical-align: top;
            }
          }
          .phoneNubmer {
            line-height: 1.25rem;
            font-size: 1rem;
            margin-left: 11px;
            display: inline-block;
          }
        }
        &::after {
          content: '.';
          clear: both;
          width: 0;
          height: 0;
          display: block;
          visibility: hidden;
        }
      }
      .help {
        text-align: center;
        margin: 5px;
        a {
          color: #595757;
        }
      }
      #license {
        clear: both;
        text-align: center;
        padding-bottom: 15px;
      }
    }
  }
}
@media screen and (max-width: 350px) {
  footer {
    .wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .contact-us {
        // width: 200px !important;
        float: left !important;
        // margin-top: 20px !important;
        // margin-left: 40px !important;
        margin: 38px 0px;
      }
      .contact-information {
        margin-right: 10px !important;
      }
      .help {
        text-align: center;
        margin: 5px;
        a {
          color: #595757;
        }
      }
      #license {
        clear: both;
        text-align: center;
        padding-bottom: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue